module.exports = __webpack_public_path__ + "img/Webhook.378542d2.svg";